<template>
    <div class="container">
        <div class="row justify-content-center">
            <h1 v-if="isNewUser" class="title text-center">Bienvenue à bord !</h1>
            <h1 v-if="!isNewUser && !isUserFull" class="title text-center">Votre compte client Armor-Lux est à jour !</h1>
            <h1 v-if="!isNewUser && isUserFull" class="title text-center">Vous êtes déjà inscrit !</h1>
        </div>
        <div class="row justify-content-center mt-3">
            <p v-if="!isUserFull" class="text-center">Pour profiter de votre <strong>remise de 10%*</strong>, <br> présentez le code-barres ci-dessous lors <br> de votre passage en caisse :</p>
            <p v-if="!isNewUser && isUserFull" class="text-center">Rendez-vous en caisse avec le code-barres ci-dessous, pour bénéficier de <strong>votre remise de 10%*</strong>.</p>
        </div>
        <div class="row justify-content-center mt-3">
            <CodeBarre :codeClient=codeClient :scale="2"/>
        </div>
        
    </div>
</template>

<script>
import CodeBarre from '../CodeBarre.vue';

export default {
    name: 'StepConfirm',
    components: {
        CodeBarre
    },
    props: {
        userData: Object,
        codeClient: String,
        userExists: Number,
        userFull: Number
    },
    computed: {
        isNewUser() {
            return this.userExists === 0;
        },
        isUserFull() {
            return this.userFull === 1;
        }
    }
}

</script>